import { IBaseResource } from "../api.types";

export enum TaskType {
    SCOPE_CREATION = "scope_creation",
}

export enum TaskStatus {
    PENDING = "pending",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
    FAILED = "failed",
    EXPIRED = "expired",
}

export interface ITaskResult {
    scope_id?: number;
}

export interface ITask extends IBaseResource {
    type: TaskType;
    progress: number;
    status: TaskStatus;
    result?: ITaskResult;
    error?: string;
}

export interface ITaskIdentifier {
    task_id: string | null;
    library_folder_id?: number;
    scope_id?: number;
    library_document_id?: number;
}
